import { adaptedToEmail, emailToAdapted } from "../../adapter/emailAdapter";
import { HttpMethod, initFetch } from "../../utils/fetcher";

export const LOAD_SUCCESS_EMAILS = "LOAD_SUCCESS_EMAILS";
export const LOAD_FAIL_EMAILS = "LOAD_FAIL_EMAILS";
export const SAVE_SUCCESS_EMAILS = "SAVE_SUCCESS_EMAILS";
export const SAVE_FAIL_EMAILS = "SAVE_FAIL_EMAILS";
export const UPDATE_SUCCESS_EMAILS = "UPDATE_SUCCESS_EMAILS";
export const UPDATE_FAIL_EMAILS = "UPDATE_FAIL_EMAILS";
export const DELETE_SUCCESS_EMAILS = "DELETE_SUCCESS_EMAILS";
export const DELETE_FAIL_EMAILS = "DELETE_FAIL_EMAILS";

export const SAVE_SUCCESS_LOT_EMAIL = "SAVE_SUCCESS_LOT_EMAIL";
export const SAVE_SUCCESS_REQUETE_EMAIL = "SAVE_SUCCESS_REQUETE_EMAIL";
export const DELETE_SUCCESS_REQUETE_EMAIL = "DELETE_SUCCESS_REQUETE_EMAIL";

export const SAVE_SUCCESS_RENDUA_EMAIL = "SAVE_SUCCESS_RENDUA_EMAIL";

export function saveEmail(jsonData) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const { url, params } = initFetch(`emails`, HttpMethod.POST);
      // make async call to database
      fetch(url, { ...params, body: JSON.stringify(adaptedToEmail(jsonData)) })
        .then((res) => {
          if (!res.ok) {
            throw new Error(`Erreur ${res.status} lors de l'envoi de l'email`);
          }
          return res.json();
        })
        .then((res) => {
          if (res.email.lot_id) {
            dispatch({
              type: SAVE_SUCCESS_LOT_EMAIL,
              payload: emailToAdapted(res.email),
            });
          } else {
            dispatch({
              type: SAVE_SUCCESS_REQUETE_EMAIL,
              payload: emailToAdapted(res.email),
            });
          }
          resolve(res.email);
        })
        .catch((err) => {
          dispatch({
            type: SAVE_FAIL_EMAILS,
            error: err,
          });
          reject(err);
        });
    });
  };
}

export function updateEmail(jsonData, id) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const { url, params } = initFetch(`emails/${id}`, HttpMethod.PUT);
      // make async call to database
      fetch(url, { ...params, body: JSON.stringify(adaptedToEmail(jsonData)) })
        .then((res) => res.json())
        .then((res) => {
          resolve(res.email);
          dispatch({
            type: UPDATE_SUCCESS_EMAILS,
            payload: emailToAdapted(res.email),
          });
        })
        .catch((err) =>
          dispatch({
            type: UPDATE_FAIL_EMAILS,
            error: err,
          })
        );
    });
  };
}

export function deleteEmail(id) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const { url, params } = initFetch(`emails/${id}`, HttpMethod.DELETE);
      // make async call to database
      fetch(url, params)
        .then((res) => {
          if (res.ok) {
            return res.json();
          } else {
            throw new Error("500");
          }
        })
        .then((res) => {
          resolve(res.email);
          dispatch({
            type: DELETE_SUCCESS_REQUETE_EMAIL,
            payload: emailToAdapted(res.email),
            id: id,
          });
        })
        .catch((err) => {
          reject(err);
          dispatch({
            type: DELETE_FAIL_EMAILS,
            error: err,
          });
        });
    });
  };
}
